
import Vue from "vue";

export default Vue.extend({
  props: {
    forBusiness: {
      type: Boolean,
      default: false,
    },
  },
});
